import { statementUnits } from '../backend/accountBankStatementRecovery';
import { bankBookedDate } from './workspaceFilters';

const exactUnits = value => {
  if (typeof value === 'number') {
    if (!Number.isFinite(value) || Math.abs(value) >= 1e12 || Number(value.toFixed(4)) !== value) throw new Error('Invalid source amount');
    value = value.toFixed(4);
  }
  return statementUnits(value);
};
const amount = (row, kind) => row.exact?.[kind] ?? row[kind]
  ?? (typeof row.signedAmount === 'number' ? Math.max(0, kind === 'credit' ? row.signedAmount : -row.signedAmount) : undefined);
const reference = value => value == null ? '' : String(value).trim();

// Compare values, not decimal padding or legacy BKT date formatting. Do not
// round source amounts or change either record while checking an overlap.
export function sourceMovementDifferences(existing, source) {
  const differences = [];
  for (const kind of ['debit', 'credit']) {
    try { if (exactUnits(amount(existing, kind)) !== exactUnits(amount(source, kind))) differences.push(kind); }
    catch { differences.push(kind); }
  }
  const date = bankBookedDate(source.bookedAt), existingDate = bankBookedDate(existing.bookedAt);
  if (!date || !existingDate || date !== existingDate) differences.push('booked date');
  if (!source.currency || existing.currency !== source.currency) differences.push('currency');
  if (reference(existing.reference) !== reference(source.reference)) differences.push('bank reference');
  if (existing.sourceAccountFingerprint && source.sourceAccountFingerprint
    && existing.sourceAccountFingerprint !== source.sourceAccountFingerprint) differences.push('bank account');
  return differences;
}

export function sourceMovementComparison(existing, source, differences = sourceMovementDifferences(existing, source)) {
  const fields = [
    ['booked date', 'Booking date', row => row.bookedAt],
    ['debit', 'Outgoing amount', row => amount(row, 'debit')],
    ['credit', 'Incoming amount', row => amount(row, 'credit')],
    ['currency', 'Currency', row => row.currency],
    ['bank reference', 'Bank reference', row => row.reference],
    ['bank account', 'Bank account', row => row.sourceAccountDisplay || 'Account identity differs'],
  ];
  return fields.filter(([field]) => differences.includes(field)).map(([field, label, read]) => ({
    field, label, saved: String(read(existing) ?? ''), statement: String(read(source) ?? ''),
  }));
}
